var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v("\n        Copyright ⓒ FITTODAYCARE.Ins. All Rights Reserved\n    ")])])
}]

export { render, staticRenderFns }